export default {
  own_profile: require("./payment/own_profile.json"),
  mockSocket: require("./websocket/data.json"),
};
